module.exports = __webpack_public_path__ + "static/media/giftLogo.4dab0c9e.png";